export default __webpack_public_path__ + "static/media/child3.43b2b93d.png";